import React, { useState, useEffect } from 'react'
import { Table, Avatar, Spin, Space, Tag, Tooltip, Select, Button } from 'antd'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { InfoCircleOutlined } from '@ant-design/icons'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'

function AdminOrders() {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [orders, setOrders] = useState([])

  const columns = [
    {
      title: 'User',
      key: 'user',
      render: (row) => (
        <div>
          <Space size="middle">
            <a href={`/member/${row.userDetails?._id}`} target="_blank" style={{ color: '#1677ff', cursor: 'pointer' }}>
              {row.userDetails?.firstName} {row.userDetails?.lastName}
            </a>
          </Space>
        </div>
      ),
      width: 180,
    },
    {
      title: 'Products',
      key: 'products',
      render: (row) => (
        <div>
          {row.products.map((item) => (
            <Space key={item._id} style={{ display: 'flex', marginBottom: 10 }}>
              <Avatar size={40} src={item.details?.attachments?.[0]?.mediaLink} />
              <a href={`/manageStore/addProducts?id=${item.details?._id}`} target="_blank" style={{ color: '#1677ff', cursor: 'pointer' }}>
                <div>{item.details?.name}</div>
                <div style={{ fontSize: 11, color: '#999' }}>{item.details?.requiredPoints} pts</div>
                {item.selectedSize && <div style={{ fontSize: 11, color: '#999' }}>Selected size: {item.selectedSize}</div>}
              </a>
            </Space>
          ))}
        </div>
      ),
    },
    {
      title: 'Type',
      dataIndex: 'deliveryMethod',
      key: 'deliveryMethod',
      width: 120,
      render: (_, record) => {
        const val = record.deliveryMethod

        if (val === 'delivery' || val === 'pickup') {
          const d = record.deliveryDetails || {}

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <b>{val === 'delivery' ? 'Delivery' : 'Pickup'}</b>

              <Tooltip
                trigger="click"
                title={
                  <div>
                    <div>
                      <b>Name:</b> {d.fullName || '-'}
                    </div>
                    <div>
                      <b>Email:</b> {d.email || '-'}
                    </div>
                    <div>
                      <b>Phone:</b> {d.phone || '-'}
                    </div>
                    <div>
                      <b>Street:</b> {d.streetAddress || '-'}
                    </div>
                    <div>
                      <b>City:</b> {d.city || '-'}
                    </div>
                    <div>
                      <b>State:</b> {d.state || '-'}
                    </div>
                    <div>
                      <b>Zip:</b> {d.zipCode || '-'}
                    </div>
                  </div>
                }
              >
                <InfoCircleOutlined style={{ color: 'blue', cursor: 'pointer' }} />
              </Tooltip>
            </div>
          )
        }

        return <b>-</b>
      },
    },
    {
      title: 'Total Points',
      dataIndex: 'totalRequiredPoints',
      key: 'totalRequiredPoints',
      width: 120,
      render: (val) => <b>{val}</b>,
    },
    {
      title: 'Status',
      key: 'status',
      width: 150,
      render: (row) => (
        <Select
          defaultValue={row.status}
          style={{ minWidth: 150 }}
          onChange={(value) => updateStatus(row, value)}
          options={[
            { value: 'pending', label: 'Pending' },
            { value: 'cancelled', label: 'Cancelled' },
            { value: 'outForDelivery', label: 'Out For Delivery' },
            { value: 'completed', label: 'Completed' },
          ]}
        />
      ),
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 150,
      render: (time) => <div style={{ fontSize: 11 }}>{moment(time).format('DD MMM YYYY, h:mm a')}</div>,
    },
  ]

  // -------------------------
  // Get all orders for admin
  // -------------------------
  const getOrders = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/storeFront/getAllOrdersForAdmin`)
      setOrders(response.data.allOrders)

      setLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  // -------------------------
  // Update order status
  // -------------------------
  const updateStatus = async (row, newStatus) => {
    try {
      if (row.status == 'cancelled' || row.status == 'completed') {
        alert('Only pending order status is changeable.')
        return
      }

      await axiosInstance.put(`/api/v1/storeFront/updateOrderStatus?orderId=${row._id}`, {
        status: newStatus,
      })

      // refresh UI
      getOrders()
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    getOrders()
  }, [])

  return (
    <Layout>
      <Button onClick={() => navigate(-1)} style={{ marginBottom: 20 }}>
        Back
      </Button>

      <h2>All Orders</h2>

      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spin size="large" />
        </div>
      )}

      <Table
        dataSource={orders}
        columns={columns}
        rowKey="_id"
        scroll={{ x: 1300 }}
        pagination={{
          pageSize: 10,
          position: ['bottomCenter'],
        }}
      />
    </Layout>
  )
}

export default AdminOrders
